/* eslint-disable no-restricted-syntax */
export default function checkApplyEditsErrors(response) {
  // Check if there is a global error in the response
  if (response.error) {
    // Log the error message to the console
    console.error("Error in applyEdits request:", response.error);
    // Return true to indicate that an error was found
    return true;
  }

  // Loop through the addFeatureResults in the response
  for (const editResult of response.addFeatureResults) {
    // Check if there was an error adding a feature
    if (editResult.error) {
      // Log the error message to the console
      console.error("Error adding feature:", editResult.error);
      // Return true to indicate that an error was found
      return true;
    }
  }

  // Loop through the updateFeatureResults in the response
  for (const editResult of response.updateFeatureResults) {
    // Check if there was an error updating a feature
    if (editResult.error) {
      // Log the error message to the console
      console.error("Error updating feature:", editResult.error);
      // Return true to indicate that an error was found
      return true;
    }
  }

  // Loop through the deleteFeatureResults in the response
  for (const editResult of response.deleteFeatureResults) {
    // Check if there was an error deleting a feature
    if (editResult.error) {
      // Log the error message to the console
      console.error("Error deleting feature:", editResult.error);
      // Return true to indicate that an error was found
      return true;
    }
  }

  // If no errors were found, return false
  return false;
}
